module.exports = __webpack_public_path__ + "img/misa.6a2a982a.png";